import api from "@/lib/api";

export async function getAssetsPresignedUrlAluno({ link, id }) {
  try {
    const { data } = await api.get("/secretaria-digital/assets/aluno", { params: { objectName: link, id } })
    return { error: false, url: data.url }
  } catch (error) {
    return { error: true, url: null }
  }
}